import styled from '@emotion/styled';

export const AppWrapper = styled.div`
  display: flex;
  padding: var(--app-padding-vertical, 15px) var(--app-padding-horizontal, 15px);
  margin: 0 auto;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.md.down} {
    justify-content: center;
  }
  ${({ theme }) => theme.breakpoints.md.up} {
    flex-wrap: nowrap;
  }
  ${({ theme }) => theme.breakpoints.lg.up} {
    margin-left: 2.5%;
  }
  ${({ theme }) => theme.breakpoints.xl.up} {
    margin-left: 5%;
  }
`;

export const LeftSidebar = styled.div`
  position: relative;
  flex-basis: 100%;
  max-width: 100%;
  text-align: left;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: var(--margin-vertical-lg, 8px) 0;

  ${({ theme }) => theme.breakpoints.md.up} {
    flex-grow: 0;
    width: 100%;
    flex-shrink: 0;
    margin-right: 24px;
    flex-basis: 440px;
    max-width: 440px;
  }

  ${({ theme }) => theme.breakpoints.lg.up} {
    flex-basis: 540px;
    max-width: 540px;
    margin-right: 36px;
  }

  ${({ theme }) => theme.breakpoints.xl.up} {
    flex-basis: 640px;
    max-width: 640px;
  }
`;

export const Topline = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey40};
`;

export const Date = styled.time`
  margin: 2px 8px 6px 2px;
  display: inline-block;
`;

export const Kicker = styled.div`
  margin: 2px 0 6px;
  font-weight: 900;
  display: inline-block;
`;

export const Title = styled.h1`
  margin: 2px 0 4px;
  font-size: 28px;
  font-weight: 700;

  ${({ theme }) => theme.breakpoints.combined.sm.up} {
    font-size: 32px;
  }
  ${({ theme }) => theme.breakpoints.combined.md.up} {
    font-size: 36px;
  }
  ${({ theme }) => theme.breakpoints.combined.xl.up} {
    font-size: 40px;
  }
`;

export const SubTitle = styled.h2`
  margin: var(--margin-vertical-xl, 24px) 0 var(--margin-vertical-md, 4px);
  font-size: 16px;
  font-weight: 700;

  ${({ theme }) => theme.breakpoints.combined.sm.up} {
    font-size: 18px;
  }
  ${({ theme }) => theme.breakpoints.combined.md.up} {
    font-size: 20px;
  }
  ${({ theme }) => theme.breakpoints.combined.xl.up} {
    font-size: 22px;
  }
`;

export const IntroText = styled.div`
  margin: 8px 0;

  ${({ theme }) => theme.breakpoints.vertical.lg.up} {
    margin: 8px 0 24px;
  }

  p {
    margin: 6px 0 18px;
    line-height: 1.5;
    font-weight: 400;
    font-family: ${({ theme }) => theme.fonts.serif};
    color: ${({ theme }) => theme.colors.grey30};
    font-size: 14px;

    ${({ theme }) => theme.breakpoints.combined.sm.up} {
      font-size: 16px;
    }

    ${({ theme }) => theme.breakpoints.combined.md.up} {
      font-size: 19px;
    }
  }
`;

export const HideAfterDraw = styled.p`
  opacity: 1;

  ${({ isDrawingEnabled }) =>
    !isDrawingEnabled &&
    `
    transition: opacity 250ms linear, font-size 250ms 250ms ease-in-out, margin 250ms 250ms ease-in-out;
    font-size: 0.001px !important;
    margin: 0 !important;
    opacity: 0;
  `}
`;
